/* eslint-disable max-len */
import { TFeedBackStatus, IFeedBackStatus } from '../../interfaces';
import {
  BACKGROUND_FPAY_GREEN,
  SATISFACTORY_ANSWER_HAND,
  BACKGROUND_FPAY_ROSE,
  FAILED_ANSWER_HAND,
  SAD_FACE,
  CRYING_FACE,
  SCANN_AND_DOWNLOAD,
  GOOGLE_PLAY_STORE,
  APPLE_APP_STORE,
} from '../../utils/constants/images';

export const getFBstatus = (status: TFeedBackStatus): IFeedBackStatus => {
  switch (status) {
    case 'SUCCESS':
      return {
        background: BACKGROUND_FPAY_GREEN,
        img: SATISFACTORY_ANSWER_HAND,
        title: '¡Listo! Enviamos tu consulta.',
        subTitle:
          'Dentro de los próximos minutos nos comunicaremos contigo a tu e-mail registrado para confirmar que estamos trabajando en tu solicitud.',
        buttonTitle: 'Ok',
      };
    case 'REJECTED':
      return {
        background: BACKGROUND_FPAY_ROSE,
        img: SAD_FACE,
        title: '¡UPS!',
        subTitle:
          'En este momento estamos experimentando algunos problemas técnicos. <br><br> Sin embargo, podemos brindarte la ayuda que necesitas a través de nuestro WhatsApp Fpay.',
        buttonTitle: 'Ir al whatsApp',
      };
    case 'SUCCESS_CLOSE_ACCOUNT':
      return {
        background: BACKGROUND_FPAY_ROSE,
        img: CRYING_FACE,
        title: '¡Enviamos tu Solicitud!',
        subTitle:
          'Dentro de los próximos 3 días hábiles nos comunicaremos contigo al e-mail  registrado para confirmarte el cierre definitivo de tu cuenta.',
        buttonTitle: 'Cerrar',
      };
    case 'UNIDENTIFIED':
      return {
        background: BACKGROUND_FPAY_ROSE,
        img: FAILED_ANSWER_HAND,
        scan_img: SCANN_AND_DOWNLOAD,
        android_img: GOOGLE_PLAY_STORE,
        apple_img: APPLE_APP_STORE,
        title: '¡Ups! Todavía no eres un Fpayer',
        subTitle:
          'Revisa el número de RUT que ingresaste o <strong>descarga la App Fpay</strong> y así podrás realizar solicitudes en esta categoría de ayuda.',
        buttonTitle: 'Volver',
      };
    default:
      return {
        background: BACKGROUND_FPAY_ROSE,
        img: FAILED_ANSWER_HAND,
        title: 'Lo sentimos. Tuvimos un problema.',
        subTitle:
          'En este momento estamos experimentando algunos problemas técnicos. <br><br> Sin embargo, podemos brindarte la ayuda que necesitas a través de nuestro WhatsApp Fpay.',
        buttonTitle: 'Ir al whatsApp',
      };
  }
};
